import { render, staticRenderFns } from "./contenta.vue?vue&type=template&id=fbcee8f8&scoped=true&"
import script from "./contenta.vue?vue&type=script&lang=js&"
export * from "./contenta.vue?vue&type=script&lang=js&"
import style0 from "./contenta.vue?vue&type=style&index=0&id=fbcee8f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcee8f8",
  null
  
)

export default component.exports